import { render, staticRenderFns } from "./ModalEditTree.vue?vue&type=template&id=1c585964&scoped=true"
import script from "./ModalEditTree.vue?vue&type=script&lang=js"
export * from "./ModalEditTree.vue?vue&type=script&lang=js"
import style0 from "./ModalEditTree.vue?vue&type=style&index=0&id=1c585964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c585964",
  null
  
)

export default component.exports